// extracted by mini-css-extract-plugin
export default {"button":"styled_button__gAcbc"};